import Vue from 'vue'
import Dialog from 'bootstrap-vue-dialog'

import BootstrapVue from 'bootstrap-vue'

import '../assets/scss/app-custom.scss'

Vue.use(Dialog)
Vue.use(BootstrapVue)
